import React, { useEffect } from "react";
import "./ErrorSnackbar.css";

/**
 * ErrorSnackbar component - displays error messages at the bottom of the canvas
 * @param {Object} props
 * @param {string} props.message - Error message to display
 * @param {boolean} props.isVisible - Whether the snackbar is visible
 * @param {Function} props.onClose - Callback when snackbar should close
 * @param {number} props.autoCloseDuration - Duration in ms before auto-closing (0 = no auto-close)
 */
const ErrorSnackbar = ({
  message,
  isVisible,
  onClose,
  autoCloseDuration = 5000,
}) => {
  useEffect(() => {
    if (!isVisible || autoCloseDuration === 0) return;

    const timer = setTimeout(() => {
      onClose();
    }, autoCloseDuration);

    return () => clearTimeout(timer);
  }, [isVisible, autoCloseDuration, onClose]);

  if (!isVisible || !message) return null;

  return (
    <div className="error-snackbar">
      <span className="error-snackbar-message">{message}</span>
      <button
        className="error-snackbar-close"
        onClick={onClose}
        aria-label="Close error message"
      >
        ✕
      </button>
    </div>
  );
};

export default ErrorSnackbar;
